export class Notification {
    header: string;
    message: string;
    type: string;
}
